import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0674f2cf"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "shape-style-panel" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "点击替换形状", -1))
const _hoisted_4 = { class: "shape-pool" }
const _hoisted_5 = { class: "shape-list" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"width":"10px"} }, null, -1))
const _hoisted_8 = { class: "row" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"width":"40%"} }, "起点颜色：", -1))
const _hoisted_10 = { class: "row" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"width":"40%"} }, "终点颜色：", -1))
const _hoisted_12 = {
  key: 0,
  class: "row"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"width":"40%"} }, "渐变角度：", -1))
const _hoisted_14 = { class: "row" }

import { type Ref, ref, watch } from 'vue'
import { storeToRefs } from 'pinia'
import { useMainStore, useSlidesStore } from '@/store'
import type { PPTShapeElement, ShapeGradient, ShapeText } from '@/types/slides'
import { WEB_FONTS } from '@/configs/font'
import { type ShapePoolItem, SHAPE_LIST, SHAPE_PATH_FORMULAS } from '@/configs/shapes'
import emitter, { EmitterEvents } from '@/utils/emitter'
import useHistorySnapshot from '@/hooks/useHistorySnapshot'
import useTextFormatPainter from '@/hooks/useTextFormatPainter'
import useShapeFormatPainter from '@/hooks/useShapeFormatPainter'

import ElementOpacity from '../common/ElementOpacity.vue'
import ElementOutline from '../common/ElementOutline.vue'
import ElementShadow from '../common/ElementShadow.vue'
import ElementFlip from '../common/ElementFlip.vue'
import ColorButton from '../common/ColorButton.vue'
import TextColorButton from '../common/TextColorButton.vue'
import ShapeItemThumbnail from '@/views/Editor/CanvasTool/ShapeItemThumbnail.vue'
import CheckboxButton from '@/components/CheckboxButton.vue'
import ColorPicker from '@/components/ColorPicker/index.vue'
import Divider from '@/components/Divider.vue'
import Slider from '@/components/Slider.vue'
import Button from '@/components/Button.vue'
import ButtonGroup from '@/components/ButtonGroup.vue'
import RadioButton from '@/components/RadioButton.vue'
import RadioGroup from '@/components/RadioGroup.vue'
import Select from '@/components/Select.vue'
import SelectGroup from '@/components/SelectGroup.vue'
import Popover from '@/components/Popover.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'ShapeStylePanel',
  setup(__props) {

const mainStore = useMainStore()
const slidesStore = useSlidesStore()
const { handleElement, handleElementId, richTextAttrs, availableFonts, textFormatPainter, shapeFormatPainter } = storeToRefs(mainStore)

const handleShapeElement = handleElement as Ref<PPTShapeElement>

const fill = ref<string>('#000')
const gradient = ref<ShapeGradient>({
  type: 'linear', 
  rotate: 0,
  color: ['#fff', '#fff'],
})
const fillType = ref('fill')
const textAlign = ref('middle')

watch(handleElement, () => {
  if (!handleElement.value || handleElement.value.type !== 'shape') return

  fill.value = handleElement.value.fill || '#fff'
  gradient.value = handleElement.value.gradient || { type: 'linear', rotate: 0, color: [fill.value, '#fff'] }
  fillType.value = handleElement.value.gradient ? 'gradient' : 'fill'
  textAlign.value = handleElement.value?.text?.align || 'middle'
}, { deep: true, immediate: true })

const { addHistorySnapshot } = useHistorySnapshot()
const { toggleTextFormatPainter } = useTextFormatPainter()
const { toggleShapeFormatPainter } = useShapeFormatPainter()

const updateElement = (props: Partial<PPTShapeElement>) => {
  slidesStore.updateElement({ id: handleElementId.value, props })
  addHistorySnapshot()
}

// 设置填充类型：渐变、纯色
const updateFillType = (type: 'gradient' | 'fill') => {
  if (type === 'fill') {
    slidesStore.removeElementProps({ id: handleElementId.value, propName: 'gradient' })
    addHistorySnapshot()
  }
  else updateElement({ gradient: gradient.value })
}

// 设置渐变填充
const updateGradient = (gradientProps: Partial<ShapeGradient>) => {
  if (!gradient.value) return
  const _gradient: ShapeGradient = { ...gradient.value, ...gradientProps }
  updateElement({ gradient: _gradient })
}

// 设置填充色
const updateFill = (value: string) => {
  updateElement({ fill: value })
}

// 修改形状
const changeShape = (shape: ShapePoolItem) => {
  const { width, height } = handleElement.value as PPTShapeElement
  const props: Partial<PPTShapeElement> = {
    viewBox: shape.viewBox,
    path: shape.path,
    special: shape.special,
  }
  if (shape.pathFormula) {
    props.pathFormula = shape.pathFormula
    props.viewBox = [width, height]

    const pathFormula = SHAPE_PATH_FORMULAS[shape.pathFormula]
    if ('editable' in pathFormula) {
      props.path = pathFormula.formula(width, height, pathFormula.defaultValue)
      props.keypoint = pathFormula.defaultValue
    }
    else props.path = pathFormula.formula(width, height)
  }
  else {
    props.pathFormula = undefined
    props.keypoint = undefined
  }
  updateElement(props)
}

const updateTextAlign = (align: 'top' | 'middle' | 'bottom') => {
  const _handleElement = handleElement.value as PPTShapeElement
  
  const defaultText: ShapeText = {
    content: '',
    defaultFontName: '微软雅黑',
    defaultColor: '#000',
    align: 'middle',
  }
  const _text = _handleElement.text || defaultText
  updateElement({ text: { ..._text, align } })
}

const fontSizeOptions = [
  '12px', '14px', '16px', '18px', '20px', '22px', '24px', '28px', '32px',
  '36px', '40px', '44px', '48px', '54px', '60px', '66px', '72px', '76px',
  '80px', '88px', '96px', '104px', '112px', '120px',
]

const emitRichTextCommand = (command: string, value?: string) => {
  emitter.emit(EmitterEvents.RICH_TEXT_COMMAND, { action: { command, value } })
}

return (_ctx: any,_cache: any) => {
  const _component_IconDown = _resolveComponent("IconDown")!
  const _component_IconFontSize = _resolveComponent("IconFontSize")!
  const _component_IconAddText = _resolveComponent("IconAddText")!
  const _component_IconText = _resolveComponent("IconText")!
  const _component_IconHighLight = _resolveComponent("IconHighLight")!
  const _component_IconTextBold = _resolveComponent("IconTextBold")!
  const _component_IconTextItalic = _resolveComponent("IconTextItalic")!
  const _component_IconTextUnderline = _resolveComponent("IconTextUnderline")!
  const _component_IconStrikethrough = _resolveComponent("IconStrikethrough")!
  const _component_IconFormat = _resolveComponent("IconFormat")!
  const _component_IconFormatBrush = _resolveComponent("IconFormatBrush")!
  const _component_IconAlignTextLeft = _resolveComponent("IconAlignTextLeft")!
  const _component_IconAlignTextCenter = _resolveComponent("IconAlignTextCenter")!
  const _component_IconAlignTextRight = _resolveComponent("IconAlignTextRight")!
  const _component_IconAlignTextTopOne = _resolveComponent("IconAlignTextTopOne")!
  const _component_IconAlignTextMiddleOne = _resolveComponent("IconAlignTextMiddleOne")!
  const _component_IconAlignTextBottomOne = _resolveComponent("IconAlignTextBottomOne")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(_component_IconDown)
    ]),
    _createElementVNode("div", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(SHAPE_LIST), (item) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "category",
          key: item.type
        }, [
          _createElementVNode("div", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.children, (shape, index) => {
              return (_openBlock(), _createElementBlock(_Fragment, null, [
                (shape.title !== '任意多边形')
                  ? (_openBlock(), _createBlock(ShapeItemThumbnail, {
                      class: "shape-item",
                      key: index,
                      shape: shape,
                      onClick: ($event: any) => (changeShape(shape))
                    }, null, 8, ["shape", "onClick"]))
                  : _createCommentVNode("", true)
              ], 64))
            }), 256))
          ])
        ]))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(Select, {
        style: {"flex":"1"},
        value: fillType.value,
        "onUpdate:value": _cache[0] || (_cache[0] = value => updateFillType(value as 'fill' | 'gradient')),
        options: [
          { label: '纯色填充', value: 'fill' },
          { label: '渐变填充', value: 'gradient' },
        ]
      }, null, 8, ["value"]),
      _hoisted_7,
      (fillType.value === 'fill')
        ? (_openBlock(), _createBlock(Popover, {
            key: 0,
            trigger: "click",
            style: {"flex":"1"}
          }, {
            content: _withCtx(() => [
              _createVNode(ColorPicker, {
                modelValue: fill.value,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = value => updateFill(value))
              }, null, 8, ["modelValue"])
            ]),
            default: _withCtx(() => [
              _createVNode(ColorButton, { color: fill.value }, null, 8, ["color"])
            ]),
            _: 1
          }))
        : (_openBlock(), _createBlock(Select, {
            key: 1,
            style: {"flex":"1"},
            value: gradient.value.type,
            "onUpdate:value": _cache[2] || (_cache[2] = value => updateGradient({ type: value as 'linear' | 'radial' })),
            options: [
          { label: '线性渐变', value: 'linear' },
          { label: '径向渐变', value: 'radial' },
        ]
          }, null, 8, ["value"]))
    ]),
    (fillType.value === 'gradient')
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("div", _hoisted_8, [
            _hoisted_9,
            _createVNode(Popover, {
              trigger: "click",
              style: {"width":"60%"}
            }, {
              content: _withCtx(() => [
                _createVNode(ColorPicker, {
                  modelValue: gradient.value.color[0],
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = value => updateGradient({ color: [value, gradient.value.color[1]] }))
                }, null, 8, ["modelValue"])
              ]),
              default: _withCtx(() => [
                _createVNode(ColorButton, {
                  color: gradient.value.color[0]
                }, null, 8, ["color"])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_10, [
            _hoisted_11,
            _createVNode(Popover, {
              trigger: "click",
              style: {"width":"60%"}
            }, {
              content: _withCtx(() => [
                _createVNode(ColorPicker, {
                  modelValue: gradient.value.color[1],
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = value => updateGradient({ color: [gradient.value.color[0], value] }))
                }, null, 8, ["modelValue"])
              ]),
              default: _withCtx(() => [
                _createVNode(ColorButton, {
                  color: gradient.value.color[1]
                }, null, 8, ["color"])
              ]),
              _: 1
            })
          ]),
          (gradient.value.type === 'linear')
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _hoisted_13,
                _createVNode(Slider, {
                  style: {"width":"60%"},
                  min: 0,
                  max: 360,
                  step: 15,
                  value: gradient.value.rotate,
                  "onUpdate:value": _cache[5] || (_cache[5] = value => updateGradient({ rotate: value as number }))
                }, null, 8, ["value"])
              ]))
            : _createCommentVNode("", true)
        ], 64))
      : _createCommentVNode("", true),
    _createVNode(ElementFlip),
    _createVNode(Divider),
    (_unref(handleShapeElement).text?.content)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createVNode(SelectGroup, { class: "row" }, {
            default: _withCtx(() => [
              _createVNode(Select, {
                class: "font-select",
                style: {"width":"60%"},
                value: _unref(richTextAttrs).fontname,
                "onUpdate:value": _cache[6] || (_cache[6] = value => emitRichTextCommand('fontname', value as string)),
                options: [
            ..._unref(availableFonts),
            ..._unref(WEB_FONTS)
          ]
              }, {
                icon: _withCtx(() => [
                  _createVNode(_component_IconFontSize)
                ]),
                _: 1
              }, 8, ["value", "options"]),
              _createVNode(Select, {
                style: {"width":"40%"},
                value: _unref(richTextAttrs).fontsize,
                "onUpdate:value": _cache[7] || (_cache[7] = value => emitRichTextCommand('fontsize', value as string)),
                options: fontSizeOptions.map(item => ({
            label: item, value: item
          }))
              }, {
                icon: _withCtx(() => [
                  _createVNode(_component_IconAddText)
                ]),
                _: 1
              }, 8, ["value", "options"])
            ]),
            _: 1
          }),
          _createVNode(ButtonGroup, {
            class: "row",
            passive: ""
          }, {
            default: _withCtx(() => [
              _createVNode(Popover, {
                trigger: "click",
                style: {"width":"30%"}
              }, {
                content: _withCtx(() => [
                  _createVNode(ColorPicker, {
                    modelValue: _unref(richTextAttrs).color,
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = value => emitRichTextCommand('color', value))
                  }, null, 8, ["modelValue"])
                ]),
                default: _withCtx(() => [
                  _withDirectives((_openBlock(), _createBlock(TextColorButton, {
                    first: "",
                    color: _unref(richTextAttrs).color
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_IconText)
                    ]),
                    _: 1
                  }, 8, ["color"])), [
                    [_directive_tooltip, '文字颜色']
                  ])
                ]),
                _: 1
              }),
              _createVNode(Popover, {
                trigger: "click",
                style: {"width":"30%"}
              }, {
                content: _withCtx(() => [
                  _createVNode(ColorPicker, {
                    modelValue: _unref(richTextAttrs).backcolor,
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = value => emitRichTextCommand('backcolor', value))
                  }, null, 8, ["modelValue"])
                ]),
                default: _withCtx(() => [
                  _withDirectives((_openBlock(), _createBlock(TextColorButton, {
                    color: _unref(richTextAttrs).backcolor
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_IconHighLight)
                    ]),
                    _: 1
                  }, 8, ["color"])), [
                    [_directive_tooltip, '文字高亮']
                  ])
                ]),
                _: 1
              }),
              _withDirectives((_openBlock(), _createBlock(Button, {
                class: "font-size-btn",
                style: {"width":"20%"},
                onClick: _cache[10] || (_cache[10] = ($event: any) => (emitRichTextCommand('fontsize-add')))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_IconFontSize),
                  _createTextVNode("+")
                ]),
                _: 1
              })), [
                [_directive_tooltip, '增大字号']
              ]),
              _withDirectives((_openBlock(), _createBlock(Button, {
                last: "",
                class: "font-size-btn",
                style: {"width":"20%"},
                onClick: _cache[11] || (_cache[11] = ($event: any) => (emitRichTextCommand('fontsize-reduce')))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_IconFontSize),
                  _createTextVNode("-")
                ]),
                _: 1
              })), [
                [_directive_tooltip, '减小字号']
              ])
            ]),
            _: 1
          }),
          _createVNode(ButtonGroup, { class: "row" }, {
            default: _withCtx(() => [
              _withDirectives((_openBlock(), _createBlock(CheckboxButton, {
                style: {"flex":"1"},
                checked: _unref(richTextAttrs).bold,
                onClick: _cache[12] || (_cache[12] = ($event: any) => (emitRichTextCommand('bold')))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_IconTextBold)
                ]),
                _: 1
              }, 8, ["checked"])), [
                [_directive_tooltip, '加粗']
              ]),
              _withDirectives((_openBlock(), _createBlock(CheckboxButton, {
                style: {"flex":"1"},
                checked: _unref(richTextAttrs).em,
                onClick: _cache[13] || (_cache[13] = ($event: any) => (emitRichTextCommand('em')))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_IconTextItalic)
                ]),
                _: 1
              }, 8, ["checked"])), [
                [_directive_tooltip, '斜体']
              ]),
              _withDirectives((_openBlock(), _createBlock(CheckboxButton, {
                style: {"flex":"1"},
                checked: _unref(richTextAttrs).underline,
                onClick: _cache[14] || (_cache[14] = ($event: any) => (emitRichTextCommand('underline')))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_IconTextUnderline)
                ]),
                _: 1
              }, 8, ["checked"])), [
                [_directive_tooltip, '下划线']
              ]),
              _withDirectives((_openBlock(), _createBlock(CheckboxButton, {
                style: {"flex":"1"},
                checked: _unref(richTextAttrs).strikethrough,
                onClick: _cache[15] || (_cache[15] = ($event: any) => (emitRichTextCommand('strikethrough')))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_IconStrikethrough)
                ]),
                _: 1
              }, 8, ["checked"])), [
                [_directive_tooltip, '删除线']
              ])
            ]),
            _: 1
          }),
          _createVNode(ButtonGroup, { class: "row" }, {
            default: _withCtx(() => [
              _withDirectives((_openBlock(), _createBlock(CheckboxButton, {
                style: {"flex":"1"},
                onClick: _cache[16] || (_cache[16] = ($event: any) => (emitRichTextCommand('clear')))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_IconFormat)
                ]),
                _: 1
              })), [
                [_directive_tooltip, '清除格式']
              ]),
              _withDirectives((_openBlock(), _createBlock(CheckboxButton, {
                style: {"flex":"1"},
                checked: !!_unref(textFormatPainter),
                onClick: _cache[17] || (_cache[17] = ($event: any) => (_unref(toggleTextFormatPainter)())),
                onDblclick: _cache[18] || (_cache[18] = ($event: any) => (_unref(toggleTextFormatPainter)(true)))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_IconFormatBrush)
                ]),
                _: 1
              }, 8, ["checked"])), [
                [_directive_tooltip, '格式刷（双击连续使用）']
              ])
            ]),
            _: 1
          }),
          _createVNode(Divider),
          _createVNode(RadioGroup, {
            class: "row",
            "button-style": "solid",
            value: _unref(richTextAttrs).align,
            "onUpdate:value": _cache[19] || (_cache[19] = value => emitRichTextCommand('align', value))
          }, {
            default: _withCtx(() => [
              _withDirectives((_openBlock(), _createBlock(RadioButton, {
                value: "left",
                style: {"flex":"1"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_IconAlignTextLeft)
                ]),
                _: 1
              })), [
                [_directive_tooltip, '左对齐']
              ]),
              _withDirectives((_openBlock(), _createBlock(RadioButton, {
                value: "center",
                style: {"flex":"1"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_IconAlignTextCenter)
                ]),
                _: 1
              })), [
                [_directive_tooltip, '居中']
              ]),
              _withDirectives((_openBlock(), _createBlock(RadioButton, {
                value: "right",
                style: {"flex":"1"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_IconAlignTextRight)
                ]),
                _: 1
              })), [
                [_directive_tooltip, '右对齐']
              ])
            ]),
            _: 1
          }, 8, ["value"]),
          _createVNode(RadioGroup, {
            class: "row",
            "button-style": "solid",
            value: textAlign.value,
            "onUpdate:value": _cache[20] || (_cache[20] = value => updateTextAlign(value as 'top' | 'middle' | 'bottom'))
          }, {
            default: _withCtx(() => [
              _withDirectives((_openBlock(), _createBlock(RadioButton, {
                value: "top",
                style: {"flex":"1"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_IconAlignTextTopOne)
                ]),
                _: 1
              })), [
                [_directive_tooltip, '顶对齐']
              ]),
              _withDirectives((_openBlock(), _createBlock(RadioButton, {
                value: "middle",
                style: {"flex":"1"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_IconAlignTextMiddleOne)
                ]),
                _: 1
              })), [
                [_directive_tooltip, '居中']
              ]),
              _withDirectives((_openBlock(), _createBlock(RadioButton, {
                value: "bottom",
                style: {"flex":"1"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_IconAlignTextBottomOne)
                ]),
                _: 1
              })), [
                [_directive_tooltip, '底对齐']
              ])
            ]),
            _: 1
          }, 8, ["value"]),
          _createVNode(Divider)
        ], 64))
      : _createCommentVNode("", true),
    _createVNode(ElementOutline),
    _createVNode(Divider),
    _createVNode(ElementShadow),
    _createVNode(Divider),
    _createVNode(ElementOpacity),
    _createVNode(Divider),
    _createElementVNode("div", _hoisted_14, [
      _withDirectives((_openBlock(), _createBlock(CheckboxButton, {
        style: {"flex":"1"},
        checked: !!_unref(shapeFormatPainter),
        onClick: _cache[21] || (_cache[21] = ($event: any) => (_unref(toggleShapeFormatPainter)())),
        onDblclick: _cache[22] || (_cache[22] = ($event: any) => (_unref(toggleShapeFormatPainter)(true)))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_IconFormatBrush),
          _createTextVNode(" 形状格式刷")
        ]),
        _: 1
      }, 8, ["checked"])), [
        [_directive_tooltip, '双击连续使用']
      ])
    ])
  ]))
}
}

})